import pagesNames from "../../constants/pages-names";

const ourCommitmentsPageData = {
    title : "Our Commitments",
    headerImage : {
        name : "our-commitments-header-image.jpg",
        alt : "A man standing in front of SAB logo",
    },
    gridOne : {
        rowOne : [
            {
                title : "Transition to Net Zero",
                subtitle : "The Paris Agreement international treaty on climate change aims to limit the global temperature rise to 2°C maximum – but preferably 1.5°C - compared with pre-industrial levels. To achieve this long-term temperature goal, all countries should aim to achieve Net Zero greenhouse gas emissions in approximately the next 3 decades. We at SAB grasp clearly that addressing climate change is an urgent and complex challenge that demands a fundamental transformation of the global economy.",
                image : {
                    name : "transition-to-net-zero-card.jpg",
                    alt : "transtion to net zero"
                },
                button : {
                    text : "Read More",
                    path : pagesNames.transition,
                }
            },
            {
                title : "Sustainable Products and Services",
                subtitle : "Our sustainable financing initiatives are showing the way forward, with SAB being the first Saudi financing institution to initiate a green deposit.",
                image : {
                    name : "sustainable-projects.jpg",
                    alt : "Sustainable Products and Services"
                },
                button : {
                    text : "Read More",
                    path : pagesNames.sustainableFinancing,
                }
            }
        ],
        rowTwo : [
            {
                title : "Engergy and Emissions",
                subtitle : "To support SAB’s operational Net Zero target by 2035, SAB's energy reduction initiatives include replacing old monitors with Liquid Crystal Display (LCD) monitors and installing light sensors to ensure that all lights are switched off after working hours. All the Bank’s lights are also connected to timers as part of the building management system to help reduce electricity usage. The recycled materials used in our installed floors, along with the highly insulated walls, reduce heat exchange to limit the need for air-conditioning.",
                button : {
                    text : "Read More",
                    path : pagesNames.emissions,
                },
                image : null
            },
            {
                title : "Vision 2030",
                subtitle : "SAB is proud to participate in fulfilling the Kingdom’s Vision 2030 goals by committing near a quarter of our balance sheet to finance the sustainability transition",
                button : {
                    text : "Read More",
                    path : pagesNames.vision,
                },
                image : {
                    name : "vision.jpg",
                    alt : "Beautiful view for a city",
                }
            }
        ]
    },
    sectionTwo : {
        title : "Saudi Green Initiative (SGI)",
        subtitle : "Saudi Arabia is stepping up its climate efforts by increasing the deployment of environmental and energy transition programs such as SGI and the Middle East Green Initiative. SGI is a national programme supported by Vision 2030. It aims to increase the vegetation cover of the Kingdom and preserve marine life, enhance biodiversity, and foster sustainable economic activities such as eco-tourism.",
        button : {
            text : "Read more",
            path : pagesNames.saudiGreen,
        }
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
}

export default ourCommitmentsPageData;